module.exports = __webpack_public_path__ + "img/cards1_front143.a660c850.png";